/**
 * A blocked held row in the quantity grid's Issues column, rendered the way every table renders a
 * blocked row (`BlockedIssue`): read-only, nothing to click.
 */
import { BlockedIssue } from "$root/ui-lib/table/custom-column/instrument/issue-cell";
import type { ColDef } from "ag-grid-community";
import type { CustomCellRendererProps } from "ag-grid-react";
import type { Instrument } from "../../const";
import { ISSUE_RANK, issueRank } from "../new-instruments/withIssueCell";
import { withCellMarker } from "../withCellMarker";
import { isHeldBlocked } from "./heldIssue";

export function HeldIssueCell(props: CustomCellRendererProps<Instrument>): React.JSX.Element | null {
	const block = props.data?.heldBlock;
	if (!block) {
		return null;
	}
	return <BlockedIssue block={block} />;
}

/** A blocked held row ranks with the added instruments that cannot be held: it shows the same cell. */
function rank(row: Instrument | undefined): number {
	return row != null && isHeldBlocked(row) ? ISSUE_RANK.unfixable : issueRank(row);
}

/**
 * Layers the blocked held row onto the Issues column, its cell and its place in the column's sort.
 * Every other row renders and sorts as before.
 */
export function withHeldIssueCell(column: ColDef<Instrument>): ColDef<Instrument> {
	return {
		...withCellMarker(column, { applies: isHeldBlocked, Marker: HeldIssueCell }),
		comparator: (_a, _b, nodeA, nodeB) => rank(nodeA.data) - rank(nodeB.data),
	};
}
